export const MenuItems = [
  { title: "About", url: "#about", delay: 0.05 },
  { title: "Projects", url: "#projects", delay: 0.1 },
  { title: "Contact", url: "#contact", delay: 0.15 },
];
